import { RegistrationControllerApiFactory } from '@api-client'
import logoImage from '@assets/images/co2ai-logo.png'
import { useAsyncApi } from '@hooks/useAsyncApi'
import { Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import * as S from './styles'

export enum UserAccessActionType {
	APPROVE_ACCESS = 'approveAccess',
	DENY_ACCESS = 'denyAccess',
}

export interface UserAccessActionProps {
	actionType: UserAccessActionType
}

const UserAccessAction = ({ actionType }: UserAccessActionProps) => {
	const registrationControllerApi = useAsyncApi(
		RegistrationControllerApiFactory
	)
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const [token] = useState(searchParams.get('token') || '')
	useEffect(() => {
		if (token) {
			if (actionType === UserAccessActionType.APPROVE_ACCESS) {
				registrationControllerApi(Api => Api.approveUserAccessRequest(token))
			} else {
				registrationControllerApi(Api => Api.denyUserAccessRequest(token))
			}
		} else {
			navigate('/login')
		}
	}, [actionType, navigate, registrationControllerApi, token])

	const { t } = useTranslation('translation')

	return (
		<Grid container direction="row" justifyContent="center" mt={10}>
			<Grid item xs={10} sm={6} md={5} lg={3}>
				<S.Logo src={logoImage} />
				<Typography variant="h6" component="h2" marginTop={4}>
					{actionType === UserAccessActionType.APPROVE_ACCESS
						? t('translation:approveUserAccess')
						: t('translation:denyUserAccess')}
				</Typography>
			</Grid>
		</Grid>
	)
}

export { UserAccessAction }
